module.exports = __webpack_public_path__ + "img/new-menu.e08a70a7.png";